import { Box } from '@chakra-ui/react';
import Layout from '../common/Layout';
import { Outlet } from 'react-router-dom';
import { useRole } from '@/hooks/useRole';

const Forms = () => {
  useRole('support');
  return (
    <Box data-test-id="pact-forms">
      <Layout pageTitle={'Pact'}>
        <Outlet />
      </Layout>
    </Box>
  );
};

export default Forms;
